import { MutationFunction } from '@tanstack/react-query';
import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import { IncomeFieldType } from './types';

export interface UpdateIncomeFieldTypeParams {
  id: string;
  name?: string;
  displayName?: string | null;
  inUse?: boolean;
  formula?: string | null;
}

const updateIncomeFieldType: MutationFunction<
  IncomeFieldType,
  UpdateIncomeFieldTypeParams
> = async ({ id, ...values }) => {
  if (isMockServices())
    return await mock({
      id,
      documentTypeId: 'document-type-id',
      name: values.name ?? 'mock',
      displayName: values.displayName ?? null,
      inUse: values.inUse ?? true,
      isDeleted: false,
      formula: values.formula ?? null,
    } as IncomeFieldType);

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<{
    success: boolean;
    data: IncomeFieldType;
  }>(`/income-field-types/${id}`, {
    method: 'PUT',
    body: {
      ...(values.name !== undefined && { name: values.name }),
      ...(values.displayName !== undefined && {
        displayName: values.displayName,
      }),
      ...(values.inUse !== undefined && { inUse: values.inUse }),
      ...(values.formula !== undefined && { formula: values.formula }),
    },
  });

  if (response.data) return response.data.data;
  throw new Error('Failed to update income field type');
};

export default updateIncomeFieldType;
